import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Col, Row, Container } from "react-bootstrap";
import { DefaultImageBaseurl, endPoints } from "../constant/Environment";

const ViewModal = (props) => {
  const [viewShow, setViewShow] = useState(false);
  const { setSelectedData, selectedData } = props;
  const handleViewClose = () => {
    setViewShow(false);
  };

  return (
    <>
      <Button
        variant="primary"
        className="mrglft10"
        style={{
          background: "#0D3862",
          borderRadius: "8px",
        }}
        onClick={() => {
          setSelectedData();
          setViewShow(true);
        }}
      >
        View
      </Button>

      <Modal
        show={viewShow}
        onHide={handleViewClose}
        size="lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          closeButton
          style={{ fontSize: "24px", fontWeight: "bold" }}
        >
          View Details
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col xs={12}>
                <table className="table table-striped">
                  <tbody>
                    <tr>
                      <th>Customer ID:</th>
                      <td>{selectedData?.id_user}</td>
                      <th>Customer Name:</th>
                      <td>{selectedData?.name}</td>
                    </tr>
                    <tr>
                      <th>Offer Name:</th>
                      <td>{selectedData?.offerName}</td>
                      <th>Post Url:</th>
                      <td>{selectedData?.post_url}</td>
                    </tr>
                    <tr>
                      <th>Gold Coin :</th>
                      <td>{selectedData?.goldCoin}</td>
                    </tr>
                  </tbody>
                </table>
                <div style={{display:'flex',justifyContent:'center'}}>
                <img
                  src={`${DefaultImageBaseurl}${selectedData.post_image}`}
                  style={{ height: '50%' }}
                />
                </div>
               
              </Col>
            </Row>

            <Row>
              <Col xs={12} className="text-center">
                <Button
                  variant="primary"
                  size="lg"
                  block
                  style={{ width: "30%", marginTop: "20px" }}
                  onClick={handleViewClose}
                >
                  Close
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ViewModal;
